import { useTrEnumNamespace as e } from "./useTrEnumNamespace.mjs";
//#region src/enums/useTrListingLifecycleState.ts
var t = () => e("listingLifecycleState");
//#endregion
export { t as useTrListingLifecycleState };
